<template>
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.065 5.80994C17.1661 6.91138 17.9158 8.31457 18.2195 9.8421C18.5231 11.3696 18.367 12.9529 17.7709 14.3917C17.1748 15.8305 16.1654 17.0603 14.8705 17.9255C13.5755 18.7907 12.053 19.2525 10.4956 19.2525C8.93819 19.2525 7.41574 18.7907 6.12076 17.9255C4.82578 17.0603 3.81642 15.8305 3.2203 14.3917C2.62419 12.9529 2.46809 11.3696 2.77174 9.8421C3.07539 8.31457 3.82515 6.91138 4.92623 5.80994"
      stroke="#404A57"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10.5 1.75V10.5"
      stroke="#404A57"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  name: "IconPower",
};
</script>

<style></style>
